module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1014-8b1a199414997977a3edcb59042aa79e.png";